<template>
  <div class="page-main">
    <div class="spaceBetween">
      <page-title />
      <div v-if="this.$store.getters.roles === 3" class="spaceRight op-btn">
        <el-button
          :disabled="seletedList.length == 0"
          @click="handleDapp"
        >Connect DAPP</el-button>
      </div>
      <div v-else class="spaceRight op-btn">
        <el-button
          :disabled="userStatus != 2 || seletedList.length == 0"
          @click="handleDapp"
        >Connect DAPP</el-button>
        <el-button class="primary" :disabled="userStatus != 2" @click="handleAddWell()">
          <img src="@/assets/icons/add.png" style="width: 0.18rem">
          <span>Add Well</span>
        </el-button>
      </div>
    </div>
    <page-card :no-head="true" class="no-padding">
      <template slot="tab">
        <el-tabs v-model="active" class="page-tab" @tab-click="handleClick">
          <el-tab-pane name="OIL">
            <span slot="label">
              <svg-icon v-if="active === 'OIL'" icon-class="tn-oil" />
              <svg-icon v-else icon-class="tn-oil1" />
              Oil
            </span>
          </el-tab-pane>
          <el-tab-pane name="GAS">
            <span slot="label">
              <svg-icon v-if="active === 'GAS'" icon-class="tn-gas2" />
              <svg-icon v-else icon-class="tn-gas" />
              Gas
            </span>
          </el-tab-pane>
        </el-tabs>
      </template>
      <div slot="body" v-loading="loading" class="page-table">
        <div class="spaceBetween search-box">
          <span class="search-title">Well List</span>
          <div class="spaceLeft search-form">
            <search-date-time
              ref="date"
              label="Creation Date"
              @valChange="valChange($event, 'dateTo')"
            />
            <search-select
              ref="status"
              label="Status"
              :options="statusList"
              @valChange="valChange($event, 'status')"
            />
            <el-input
              v-model="searchData.nickname"
              style="margin-left: 0.1rem"
              class="search-input"
              placeholder="Enter well name to search…"
              @keyup.enter="getList"
            >
              <el-button slot="append" size="mini" @click="getList">
                <svg-icon icon-class="tn-search" />
              </el-button>
            </el-input>
          </div>
        </div>

        <div class="table_box">
          <el-table
            :data="wellList"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column prop="nickname" label="Well Name" />
            <el-table-column prop="timestamp" label="Creation Date">
              <template slot-scope="{ row }">
                {{ row.timestamp | time("yyyy-MM-DD") }}
              </template>
            </el-table-column>
            <el-table-column label="Unique ID">
              <template slot-scope="{ row }">
                <div v-clipboard:copy="row.uniqueId" v-clipboard:success="onCopy" class="spaceLeft">
                  <account :value="row.uniqueId" />
                  <img
                    :src="require(`@/assets/image/well/copy.png`)"
                    alt
                    style="width: 0.28rem; height: 0.22rem;cursor: pointer;"
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="Beneficiaries" label="Beneficiaries">
              <template slot-scope="{ row }">
                {{ row.beneficiaries && row.beneficiaries.length }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="Status">
              <template slot-scope="{ row }">
                <img
                  :src="require(`@/assets/image/well/icon${row.status}.png`)"
                  alt
                  style="height: 0.3rem"
                >
              </template>
            </el-table-column>
            <el-table-column label="Operation">
              <template slot-scope="{ row }">
                <div>
                  <el-button type="text" @click="toDetails(row)">Details</el-button>
                </div>
                <div>
                  <el-button
                    v-if="row.status == 3 && $store.getters.roles !== 3"
                    type="text"
                    @click="toModify(row)"
                  >Modify</el-button>
                </div>
                <div>
                  <el-button
                    v-if="row.status == 1"
                    type="text"
                    @click="changeBeneifit(row)"
                  >Change Beneifit</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pageSize"
            @pagination="getList()"
          />
        </div>
      </div>
    </page-card>
    <el-dialog :visible.sync="open" title="Choose Dapp" width="5rem">
      <div>
        <p>Please select which DAPP is associated with the assets of the well.</p>
        <br>
        <el-radio-group v-model="DappRadio">
          <el-radio
            v-for="item in dappList"
            :key="item.name"
            :label="item.account"
          >Defi</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="selectedDapp('cancel')">Cancel</el-button>
        <el-button
          type="primary"
          :disabled="!DappRadio"
          @click="selectedDapp('submit')"
        >Submit</el-button>
      </div>
    </el-dialog>
    <ConnectDAPPDia ref="ConnectDAPPDia" @success="getList" />
    <ChangeBenefitDia ref="ChangeBenefitDia" />
    <AddWellDia ref="AddWellDia" />
  </div>
</template>

<script>
/* global web3 */
import { wellList } from '@/api/well.js'
import { getInfo } from '@/api/login.js'
import SearchDateTime from '@/components/SearchDate/SearchDateTime.vue'
import ConnectDAPPDia from './ConnectDAPPDia.vue'
import ChangeBenefitDia from './ChangeBenefitDia.vue'
import AddWellDia from './AddWellDia.vue'
import { availableList } from '@/api/file.js'
export default {
  components: {
    SearchDateTime,
    ConnectDAPPDia,
    ChangeBenefitDia,
    AddWellDia
  },
  data() {
    return {
      active: 'OIL',
      loading: false,
      pageData: {
        accAddress: undefined,
        companyName: undefined,
        wellLicense: undefined
      },
      wellList: [],
      statusList: [
        {
          name: 'In Review',
          value: 0
        },
        {
          name: 'Normal',
          value: 1
        },
        {
          name: 'Expired',
          value: 2
        },
        {
          name: 'Review Failed',
          value: 3
        },
        {
          name: 'In Annual Review',
          value: 5
        },
        {
          name: 'Annual Review Failed',
          value: 6
        }
      ],
      searchData: {
        nickname: undefined
      },
      total: 0,
      queryParams: {
        page: 1,
        pageSize: 10
      },
      seletedList: [],
      userStatus: undefined,
      open: false,
      DappRadio: undefined,
      dappList: []
    }
  },
  created() {
    this.getList()
    this.getUserStatus()
  },
  methods: {
    handleClick() {
      this.queryParams.page = 1
      this.searchData = {}
      this.$refs.date.clearVal()
      this.$refs.status.clearVal()
      this.getList()
    },
    getList() {
      this.loading = true
      this.seletedList = []
      const json = {
        ...this.queryParams,
        beneficiary: this.$store.getters.roles === 3 ? true : undefined,
        ...this.searchData,
        type: this.active
      }
      wellList(json)
        .then((res) => {
          this.wellList = res.result.list.map(item => {
            return {
              ...item,
              uniqueId: this.getId(item)
            }
          })
          this.total = res.result.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    getUserStatus() {
      if (this.$store.getters.userInfo.status !== 2) {
        getInfo().then((res) => {
          this.userStatus = res.result.status
        })
      } else {
        this.userStatus = 2
      }
    },
    isObj(obj) {
      return Object.prototype.toString.call(obj) === '[object Object]'
    },
    valChange(data, key) {
      console.log(data)
      if (Array.isArray(data) && data.length > 0) {
        this.searchData.dateFrom = data[0]
        this.searchData.dateTo = data[1]
      } else {
        this.searchData[key] = this.isObj(data) ? data.value : data
      }
      this.getList()
    },
    handleSelectionChange(val) {
      this.seletedList = val
    },
    handleAddWell() {
      this.$refs.AddWellDia.show()
      // this.$router.push("/wellManagement/addWell");
    },
    toDetails(row) {
      this.$router.push({
        path: '/wellManagement/wellDetail',
        query: {
          wellID: row.wellID
        }
      })
    },
    toModify(row) {
      this.$router.push({
        path: '/wellManagement/modifyWell',
        query: {
          wellID: row.wellID
        }
      })
    },
    handleDapp() {
      availableList().then((res) => {
        this.dappList = res.data
        this.open = true
      })
    },
    selectedDapp(val) {
      if (val === 'submit') {
        const item = this.dappList.find((item) => item.account === this.DappRadio)
        this.$refs.ConnectDAPPDia.show(this.seletedList, item)
      }
      this.DappRadio = undefined
      this.open = false
    },
    changeBeneifit(row) {
      this.$refs.ChangeBenefitDia.show(row)
    },
    getId(row) {
      return web3.utils.padRight(web3.utils.toHex(row.wellID), 64)
    },
    onCopy() {
      this.$message.success('Replicating Success')
    }
  }
}
</script>
<style scoped lang="scss">
.op-btn {
  margin-bottom: 0.24rem;

  .el-button {
    padding: 0.12rem 0.16rem;
    font-size: 0.18rem;
    line-height: 0.2rem;
    color: #626871;
    border-color: #d9dde3;
    background: #fff;

    &.primary {
      background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
      border-color: transparent;
      color: #fff;
    }
  }
}

.page-table {
  .text-blue {
    color: #225bfc;
    margin-right: 0.12rem;
  }

  .text-orange {
    color: #f58000;
    margin-right: 0.12rem;
  }
}

.search-box {
  padding: 0.24rem 0.32rem;
  border-bottom: 1px solid #f0f0f0;

  .search-title {
    font-size: 0.22rem;
    font-weight: bold;
  }

  .search-item {
    margin-left: 0.24rem;
  }
}
</style>
